import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import pJson from '../../../package.json';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

export default function Footer() {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
      <Typography variant="caption"> {new Date().getFullYear()} &copy; Rubber ♥ crafted by Rubber </Typography>
      {/* <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center">
        <Link component={RouterLink} to="https://www.blueseas.co.th" target="_blank" variant="caption" color="text.primary">
          Home
        </Link>
        <Link component={RouterLink} to="https://www.blueseas.co.th" target="_blank" variant="caption" color="text.primary">
          Documentation
        </Link>
        <Link component={RouterLink} to="https://www.blueseas.co.th" target="_blank" variant="caption" color="text.primary">
          Support
        </Link>
      </Stack> */}
      v{pJson.version}
    </Stack>
  );
}
